.cell {
  display: inline-block;
  min-height: 26px;
  vertical-align: top;
  color: white;
}
